<form class="needs-validation mt-n1" [formGroup]="form" novalidate>

    <div class="row">
        <div class="col-md-12">
            <h4>{{ title }} Inspección</h4>
        </div>
    </div>            

    <div class="row">
        <div class="col-md-12">
            <div class="card card-accent-success animated fadeIn">
                <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                    <div class="card-header-buscador">
                        <i class="fa fa-file-text-o"></i> Datos de la Inspección
                        <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                        <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                    </div>
                </a>
                <div class="card-body-detalle">
                    <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                        <div class="row">

                            <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                <label class="col-form-label required-field" for="IdPeriodoInspeccionCam" title="Tipo de Inspección">Tipo de Inspección</label>
                                <ng-select appendTo="body"
                                    loadingText="Cargando..."
                                    [items]="tiposInspeccion"
                                    [readonly]="!tiposInspeccion || tiposInspeccion?.length === 0 || readonly"
                                    bindLabel="Descripcion"
                                    bindValue="Id"
                                    formControlName="IdPeriodoInspeccionCam"
                                    [loading]="tiposInspeccion === null"
                                    placeholder="-- Seleccione un Tipo de Inspección --"
                                    [ngClass]="displayFieldCssNgSelect('IdPeriodoInspeccionCam')"
                                    (change)="onSelectTipoInspeccion($event?.Id)"
                                    notFoundText="Tipo Inspección no encontrado"
                                    aria-describedby="validationPeriodoInspeccionFeedback"
                                    clearAllText="Eliminar selección">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                    </ng-template>
                                </ng-select>

                                <div id="validationPeriodoInspeccionFeedback" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPeriodoInspeccionCam','required')">
                                    Tipo de Inspección es obligatorio
                                </div>
                            </div>

                            <div *ngIf="form?.value.Inspector" class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                <!-- READONLY SET ON FORM CONSTRUCTION -->
                                <label class="col-form-label" for="Inspector">Inspector</label>
                                <input formControlName="Inspector" name="Inspector"
                                    class="form-control" id="Inspector" type="text" value="">
                            </div>

                            <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                <!-- READONLY SET ON FORM CONSTRUCTION -->
                                <label class="col-form-label" for="NombreInspeccion">Nombre Inspección</label>
                                <input formControlName="NombreInspeccion" name="NombreInspeccion"
                                    class="form-control" id="NombreInspeccion" type="text" value="">
                            </div>

                            <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                <label class="col-form-label required-field" for="IdResultadoInspeccionCam" title="Resultado de la Inspección">Resultado</label> <label>(de la "Inspección")</label>
                                <ng-select appendTo="body"
                                    loadingText="Cargando..."
                                    [items]="resultadosInspeccion"
                                    [readonly]="!resultadosInspeccion || resultadosInspeccion?.length === 0 || readonly"
                                    bindLabel="Descripcion"
                                    bindValue="Id"
                                    formControlName="IdResultadoInspeccionCam"
                                    [loading]="resultadosInspeccion === null && form.value.IdPeriodoInspeccionCam !== null"
                                    placeholder="-- Seleccione un Resultado --"
                                    [ngClass]="displayFieldCssNgSelect('IdResultadoInspeccionCam')"
                                    (change)="onSelectResultado($event?.Id, form.value.IdPeriodoInspeccionCam)"
                                    aria-describedby="validationResultadoInvalid"
                                    notFoundText="Resultado no encontrado"
                                    clearAllText="Eliminar selección">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                    </ng-template>
                                </ng-select>

                                <div id="validationResultadoInvalid" class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdResultadoInspeccionCam','required')">
                                    Resultado es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-xl-3 col-lg-4 col-md-3 col-sm-6">
                                <!-- READONLY SET ON FORM CONSTRUCTION -->
                                <label class="col-form-label" for="FechaInspeccion">Fecha Inspección</label>
                                <p-calendar appendTo="body" formControlName="FechaInspeccion" inputStyleClass="form-control" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy" [showTime]="true" hourFormat="24"></p-calendar>
                            </div>

                            <div class="form-group col-md-3">
                                <label class="col-form-label" for="FechaCaducidad" [ngClass]="{ 'required-field': requiredFechaCaducidad }">Fecha Caducidad</label>
                                <p-calendar appendTo="body" formControlName="FechaCaducidad" inputStyleClass="form-control" [minDate]="caducidadMinimumDate" [showIcon]="true" [firstDayOfWeek]="1" dateFormat="dd/mm/yy"></p-calendar>
                                <div *ngIf="!readonly && isFieldInvalid('FechaCaducidad','required')" class="invalid-feedback d-block">
                                    El tipo de inspección obliga a indicar "Fecha de Caducidad"
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaCaducidad','FechaCaducidadFueraDePeriodo', true)">
                                    La fecha de caducidad no puede ser superior a la fecha fin del periodo
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaCaducidad','FechaCaducidadFueraPlazo', true)">
                                    La fecha de caducidad es anterior al plazo de exportación vigente
                                </div>
                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('FechaCaducidad','FechaCaducidadFechaExportacion', true)">
                                    La fecha de caducidad de la inspección, no puede ser anterior a la fecha de inicio de la exportación.
                                </div>
                                
                            </div>
                            <div class="form-group col-md-12">
                                <label class="col-form-label" for="Observaciones">Observaciones</label>
                                <textarea maxlength="300" [readonly]="readonly" rows="3" formControlName="Observaciones" name="Descripcion" [ngClass]="displayFieldCss('Descripcion')" class="form-control" inputStyleClass="form-control"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</form>